import React, { useEffect, useRef } from "react";
import Dropzone from "dropzone";
import "dropzone/dist/dropzone.css";
import httpService from "../../../services/httpService";

const WorkOrderFileUpload: React.FC<{
  idSubscription: number;
  workOrderNumber: string;
  onUploadComplete?: any | undefined;
}> = ({ idSubscription, workOrderNumber, onUploadComplete }) => {
  const dropzoneRef = useRef<HTMLFormElement | null>(null);
  const dzInstance = useRef<Dropzone | null>(null);

  const apiEndpoint = "/upload";

  useEffect(() => {
    if (!dropzoneRef.current) {
      return;
    }

    const uploadUrl = `${httpService.getApiUrl()}${apiEndpoint}/workOrderFileUpload`;

    dzInstance.current = new Dropzone(dropzoneRef.current, {
      url: uploadUrl,
      method: "post",
      paramName: "files",
      uploadMultiple: false,
      parallelUploads: 5,
      maxFilesize: 10, // MB
      addRemoveLinks: false,
      dictDefaultMessage: "Drag & drop files here or click to upload",
      headers: {
        Authorization: `Bearer ${httpService.getAccessToken()}`,
      },
    });

    dzInstance.current.on("sending", (file, xhr, formData) => {
      formData.append("idSubscription", idSubscription.toString());
      formData.append("workOrderNumber", workOrderNumber);
    });

    dzInstance.current.on("success", (file, response) => {
      // console.log("Upload success:", response);
      setTimeout(() => {
        dzInstance.current?.removeFile(file);
        if (onUploadComplete) {
          onUploadComplete();
        }
      }, 2000);
    });

    dzInstance.current.on("error", (files, error) => {
      // console.error("Upload error:", error);
    });

    dzInstance.current.on("removedfile", (file) => {
      // console.log("File removed:", file.name);
    });

    dzInstance.current.on("canceled", (file) => {
      // console.log("Upload canceled:", file.name);
    });

    return () => {
      dzInstance.current?.destroy();
      dzInstance.current = null;
    };
  }, [idSubscription, workOrderNumber, onUploadComplete]);

  return (
    <div className="container mt-4">
      <form
        ref={dropzoneRef}
        className="dropzone border border-secondary rounded p-4"
      />
    </div>
  );
};

export default WorkOrderFileUpload;
